export enum ECategorie {
    Accessoire = 1,
    Equipement = 2,
    Inventaire = 3,
    Outillage = 4,
    Divers = 5,
    Mécanique = 6
}